import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CargaDescargaInfo } from "./info";
import { Lector } from "./lector";
import { EstatusCargaDescarga } from "./estatus";

const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar", iconClass: fa("check"), style: "success" });
const ImprimirButton = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto", iconClass: fa("print"), style: "info" });

export interface Props {
    value: models.CargaDescargaEADDto;
}
class CargaDescargaEADForm extends React.PureComponent<Props> {
    onRegresar = () => history.go("../");
    onFinalizar = async () => {
        if (await kea.yesno("¿Finalizar proceso?")) {
            await resources.CargaDescargaEAD.FinalizarCargaDescarga(this.props.value.IdRegistro);
            await kea.message("Proceso finalizado correctamente", "", "success");
            history.go("../");
        }
    }

    onImprimir = async () => {
        const data = await resources.CargaDescargaEAD.ReporteCargaEAD(this.props.value.IdRegistro);
        await kea.printPdf(data);
    }

    render() {
        const x = this.props.value;
        const tipo = models.TipoCargaDescarga[x.Tipo];

        return (
            <div>
                <kea.Title titulo={`${tipo} de camión de entrega a domicilio`} onRegresar={this.onRegresar} >
                    <FinalizarButton onClick={this.onFinalizar} />
                    <ImprimirButton onClick={this.onImprimir} />
                </kea.Title>

                <CargaDescargaInfo idCargaDescarga={x.IdRegistro} />
                <Lector idCargaDescarga={x.IdRegistro}  />
                <EstatusCargaDescarga idCargaDescargaEAD={x.IdRegistro}  />
            </div >
        )
    }
}

export const CargaDescargaFormRx = componentToRx(CargaDescargaEADForm);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/edit/form.tsx